import React from 'react';

export const ProjectsTable = ({ rows = null }) => {
  const data = rows || [
    { name: 'Q4 Product Update.docx', langs: ['DE', 'FR', 'JA', 'ES'], pct: 68, owner: 'MK', av: 'av-1', due: 'Apr 30', status: 'live' },
    { name: 'Brand Guidelines v3.idml', langs: ['ES', 'IT'], pct: 92, owner: 'TA', av: 'av-2', due: 'Apr 29', status: 'live' },
    { name: 'Onboarding emails.json', langs: ['+6'], pct: 40, owner: 'LY', av: 'av-3', due: 'May 04', status: 'queued' },
    { name: 'Legal — DPA.docx', langs: ['DE'], pct: 100, owner: 'YH', av: 'av-4', due: 'Apr 22', status: 'done' },
    { name: 'Spring campaign copy.xliff', langs: ['+12'], pct: 22, owner: 'MK', av: 'av-1', due: 'May 12', status: 'queued' },
    { name: 'Help center FAQs.md', langs: ['+8'], pct: 55, owner: 'LY', av: 'av-3', due: 'May 06', status: 'live' },
  ];
  return (
    <div className="proj-table">
      <div className="proj-row head">
        <span>Project</span><span>Source → target</span><span>Progress</span><span>Owner</span><span>Due</span><span>Status</span>
      </div>
      {data.map((r, i) => (
        <div className="proj-row" key={i}>
          <span className="proj-name">
            <span className="file-ic">{r.name.split('.').pop().slice(0, 3).toUpperCase()}</span>
            <span>{r.name}</span>
          </span>
          <span className="proj-langs">
            <span className="lang-chip">EN</span>
            <span style={{ color: 'var(--ink-4)', fontSize: 11, alignSelf: 'center' }}>→</span>
            {r.langs.map((l) => <span key={l} className="lang-chip">{l}</span>)}
          </span>
          <span className="proj-progress">
            <span className="bar"><span style={{ width: r.pct + '%' }}></span></span>
            <span className="proj-pct">{r.pct}%</span>
          </span>
          <span className="proj-owner">
            <span className={`av ${r.av}`}>{r.owner}</span>
          </span>
          <span className="proj-due">{r.due}</span>
          <span><span className={`status-pill ${r.status}`}><span className="pulse"></span>{r.status}</span></span>
        </div>
      ))}
    </div>
  );
};

export const EditorMock = () => (
  <div className="editor">
    <div className="editor-h">
      <span className="file">Q4 Product Update.docx · segment 12 / 248</span>
      <span className="meta">EN → DE · Mira K.</span>
    </div>
    <div className="editor-body">
      <div className="editor-pane">
        <div className="lbl">Source · English</div>
        <p>Rush Studio brings your entire <span className="gloss">localization</span> pipeline into one calm dashboard.</p>
      </div>
      <div className="editor-pane target">
        <div className="lbl">Target · German · AI draft</div>
        <p>Rush Studio bringt Ihre gesamte <span className="gloss">Lokalisierung</span>-Pipeline in ein ruhiges Dashboard.</p>
        <div style={{ fontSize: 11, color: 'var(--ink-3)', marginTop: 6 }}>3 TM matches · 1 glossary term locked</div>
        <div className="editor-actions">
          <button className="editor-action primary">Accept</button>
          <button className="editor-action">Edit</button>
          <button className="editor-action">Reject</button>
        </div>
      </div>
    </div>
  </div>
);

export const TMList = () => (
  <div className="tm-list">
    {[
      ['Welcome to your translation workspace.', 'Willkommen in Ihrem Übersetzungs-Workspace.', '98%'],
      ['Welcome to Rush Studio.', 'Willkommen bei Rush Studio.', '94%'],
      ['Welcome to the team.', 'Willkommen im Team.', '82%'],
    ].map(([s, t, m], i) => (
      <div className="tm-item" key={i}>
        <span className="tm-source">{s}</span>
        <span className="tm-target">{t}</span>
        <span className="tm-match">{m}</span>
      </div>
    ))}
  </div>
);

export const Integrations = () => {
  const items = [
    ['Google Drive', 'g'], ['Dropbox', 'b'], ['OneDrive', 'b'], ['Box', ''],
    ['Slack', 'y'], ['Figma', ''], ['GitHub', ''], ['Notion', ''],
  ];
  return (
    <div className="int-grid">
      {items.map(([n, c]) => (
        <span key={n} className="int-chip">
          <span className={`ic-sq ${c}`}></span>{n}
        </span>
      ))}
    </div>
  );
};

export const Calendar = () => (
  <div className="cal">
    {['MON 28', 'TUE 29', 'WED 30', 'THU 01', 'FRI 02', 'SAT 03', 'SUN 04'].map((d, i) => (
      <div className="cal-cell" key={d}>
        <span className="day">{d}</span>
        {i === 1 && <span className="cal-task">Brand v3 → Tomás</span>}
        {i === 2 && <><span className="cal-task b">Q4 Update → Mira</span><span className="cal-task g">DPA → Yusuf</span></>}
        {i === 4 && <span className="cal-task">FAQs → Lin</span>}
        {i === 6 && <span className="cal-task b">Emails → Lin</span>}
      </div>
    ))}
  </div>
);

const DashSidebar = ({ active = 'All projects' }) => {
  const items = [
    ['WORKSPACE', null],
    ['item', 'All projects', '24'],
    ['item', 'My queue', '7'],
    ['item', 'Inbox', '3'],
    ['WORK', null],
    ['item', 'Translation memory', null],
    ['item', 'Glossaries', null],
    ['item', 'Integrations', null],
    ['TEAM', null],
    ['item', 'People', null],
    ['item', 'Settings', null],
  ];
  return (
    <aside className="dash-side">
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 8px 12px', borderBottom: '1px solid var(--line)', marginBottom: 8 }}>
        <div style={{ width: 22, height: 22, background: 'var(--ink)', color: 'var(--bg)', borderRadius: 6, display: 'grid', placeItems: 'center', fontSize: 11, fontWeight: 700 }}>R</div>
        <div style={{ fontSize: 13, fontWeight: 600 }}>Acme · Localization</div>
      </div>
      {items.map((it, i) => {
        if (it[0] !== 'item') return <div className="dash-side-section" key={i}>{it[0]}</div>;
        const [, label, badge] = it;
        return (
          <div className={`dash-side-item ${label === active ? 'active' : ''}`} key={label}>
            <span className="ic">▢</span>
            <span>{label}</span>
            {badge && <span className="dash-side-badge">{badge}</span>}
          </div>
        );
      })}
    </aside>
  );
};

export const DashboardHero = () => {
  const [tab, setTab] = React.useState(0);
  const tabs = [
    ['01', 'Projects'],
    ['02', 'Editor'],
    ['03', 'Memory'],
    ['04', 'Files'],
    ['05', 'Deadlines'],
  ];
  return (
    <div className="dash">
      <DashSidebar />
      <div className="dash-main">
        <div className="dash-topbar">
          <span className="crumb">Acme · Localization · <b>Dashboard</b></span>
          <div className="search">⌕ Search projects, files, terms…</div>
          <div className="avatar">MK</div>
        </div>
        <div className="dash-tabs">
          {tabs.map(([ix, label], i) => (
            <div key={i} className={`dash-tab ${tab === i ? 'active' : ''}`} onClick={() => setTab(i)}>
              <span className="ix">{ix}</span>{label}
            </div>
          ))}
        </div>
        <div className="dash-content">
          {tab === 0 && (
            <>
              <div className="dash-h">
                <h4>Active projects · 24</h4>
                <div className="dash-filters">
                  <span className="filter-chip active">All</span>
                  <span className="filter-chip">My team</span>
                  <span className="filter-chip">This week</span>
                  <span className="filter-chip" style={{ background: 'var(--ink)', color: 'var(--bg)', borderColor: 'var(--ink)' }}>+ New</span>
                </div>
              </div>
              <ProjectsTable />
            </>
          )}
          {tab === 1 && (
            <>
              <div className="dash-h"><h4>Translation editor</h4></div>
              <EditorMock />
              <div style={{ marginTop: 16 }}>
                <div style={{ fontSize: 12, color: 'var(--ink-3)', marginBottom: 8, fontWeight: 600 }}>Memory matches</div>
                <TMList />
              </div>
            </>
          )}
          {tab === 2 && (
            <>
              <div className="dash-h"><h4>Memory · "welcome to"</h4><span className="filter-chip">DE · Brand voice</span></div>
              <TMList />
              <div style={{ marginTop: 16, fontSize: 12, color: 'var(--ink-3)' }}>+ 12 more matches across 4 projects · last updated 2 hours ago</div>
            </>
          )}
          {tab === 3 && (
            <>
              <div className="dash-h"><h4>Files & integrations</h4></div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                <div style={{ padding: 32, border: '2px dashed var(--line-2)', borderRadius: 12, textAlign: 'center', color: 'var(--ink-3)' }}>
                  <div style={{ fontSize: 24, marginBottom: 8 }}>↓</div>
                  <div style={{ fontWeight: 600, color: 'var(--ink)', fontSize: 14 }}>Drop files here</div>
                  <div style={{ fontSize: 12, marginTop: 4 }}>DOCX · IDML · XLIFF · JSON · MD · PPTX</div>
                </div>
                <div>
                  <div style={{ fontSize: 12, color: 'var(--ink-3)', marginBottom: 8, fontWeight: 600 }}>Connected sources</div>
                  <Integrations />
                </div>
              </div>
            </>
          )}
          {tab === 4 && (
            <>
              <div className="dash-h"><h4>This week · 11 deadlines</h4></div>
              <Calendar />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
